var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "16px",
    width: "48px",
    viewBox: "0 0 54 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.797 0.421143C5.24066 0.421143 0.736328 4.93375 0.736328 10.5003C0.736328 16.0669 5.24066 20.5795 10.797 20.5795C14.0906 20.5795 17.0146 18.994 18.8499 16.5432C20.6851 18.994 23.6091 20.5795 26.9027 20.5795C30.1899 20.5795 33.109 19 34.9449 16.5573C36.7808 19 39.6999 20.5795 42.9871 20.5795C48.5435 20.5795 53.0479 16.0669 53.0479 10.5003C53.0479 4.93375 48.5435 0.421143 42.9871 0.421143C39.6999 0.421143 36.7808 2.00063 34.9449 4.44339C33.109 2.00063 30.1899 0.421143 26.9027 0.421143C23.6091 0.421143 20.6851 2.00671 18.8499 4.45749C17.0146 2.00671 14.0906 0.421143 10.797 0.421143ZM4.76062 10.5003C4.76062 13.8403 7.46322 16.5478 10.797 16.5478C14.1309 16.5478 16.8335 13.8403 16.8335 10.5003C16.8335 7.16038 14.1309 4.45282 10.797 4.45282C7.46322 4.45282 4.76062 7.16038 4.76062 10.5003ZM36.9586 10.813C36.9618 10.7092 36.9634 10.6049 36.9634 10.5003C36.9634 10.3957 36.9618 10.2915 36.9586 10.1876C37.1211 6.99302 39.758 4.45282 42.9871 4.45282C46.321 4.45282 49.0236 7.16038 49.0236 10.5003C49.0236 13.8403 46.321 16.5478 42.9871 16.5478C39.758 16.5478 37.1211 14.0076 36.9586 10.813ZM32.9312 10.1876C32.7688 6.99302 30.1318 4.45282 26.9027 4.45282C23.5688 4.45282 20.8662 7.16038 20.8662 10.5003C20.8662 13.8403 23.5688 16.5478 26.9027 16.5478C30.1318 16.5478 32.7688 14.0076 32.9312 10.813C32.928 10.7092 32.9264 10.6049 32.9264 10.5003C32.9264 10.3957 32.928 10.2915 32.9312 10.1876Z",
    fill: "#1E961B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76061 10.5003C4.76061 13.8403 7.46322 16.5478 10.797 16.5478C14.1309 16.5478 16.8335 13.8403 16.8335 10.5003C16.8335 7.16038 14.1309 4.45282 10.797 4.45282C7.46322 4.45282 4.76061 7.16038 4.76061 10.5003ZM10.797 0.421143C5.24066 0.421143 0.736328 4.93375 0.736328 10.5003C0.736328 16.0669 5.24066 20.5795 10.797 20.5795C16.3534 20.5795 20.8578 16.0669 20.8578 10.5003C20.8578 4.93375 16.3534 0.421143 10.797 0.421143Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9501 10.5003C36.9501 13.8403 39.6527 16.5478 42.9865 16.5478C46.3203 16.5478 49.0229 13.8403 49.0229 10.5003C49.0229 7.16038 46.3203 4.45282 42.9865 4.45282C39.6527 4.45282 36.9501 7.16038 36.9501 10.5003ZM42.9865 0.421143C37.4301 0.421143 32.9258 4.93375 32.9258 10.5003C32.9258 16.0669 37.4301 20.5795 42.9865 20.5795C48.5429 20.5795 53.0472 16.0669 53.0472 10.5003C53.0472 4.93375 48.5429 0.421143 42.9865 0.421143Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8661 10.5003C20.8661 13.8403 23.5687 16.5478 26.9025 16.5478C30.2363 16.5478 32.9389 13.8403 32.9389 10.5003C32.9389 7.16038 30.2363 4.45282 26.9025 4.45282C23.5687 4.45282 20.8661 7.16038 20.8661 10.5003ZM26.9025 0.421143C21.3461 0.421143 16.8418 4.93375 16.8418 10.5003C16.8418 16.0669 21.3461 20.5795 26.9025 20.5795C32.4589 20.5795 36.9632 16.0669 36.9632 10.5003C36.9632 4.93375 32.4589 0.421143 26.9025 0.421143Z",
    fill: "#1E961B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8895 16.5482C23.5557 16.5482 20.8531 13.8407 20.853 10.5008H20.8578C20.8578 4.93424 16.3534 0.421631 10.797 0.421631C5.24067 0.421631 0.736328 4.93424 0.736328 10.5008H4.76061C4.76061 7.16087 7.46322 4.4533 10.797 4.4533C14.1308 4.4533 16.8334 7.16081 16.8335 10.5007H16.8287C16.8287 16.0673 21.3331 20.5799 26.8895 20.5799C32.4458 20.5799 36.9501 16.0673 36.9502 10.5008H36.9506C36.9506 7.16087 39.6532 4.45331 42.987 4.45331C46.3209 4.45331 49.0235 7.16087 49.0235 10.5008L53.0478 10.5008C53.0478 4.93424 48.5434 0.421631 42.987 0.421631C37.4307 0.421631 32.9264 4.93418 32.9263 10.5007H32.9259C32.9259 13.8406 30.2233 16.5482 26.8895 16.5482Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8895 16.5482C23.5557 16.5482 20.8531 13.8407 20.853 10.5008H20.8578C20.8578 4.93424 16.3534 0.421631 10.797 0.421631C5.24067 0.421631 0.736328 4.93424 0.736328 10.5008H4.76061C4.76061 7.16087 7.46322 4.4533 10.797 4.4533C14.1308 4.4533 16.8334 7.16081 16.8335 10.5007H16.8287C16.8287 16.0673 21.3331 20.5799 26.8895 20.5799C32.4458 20.5799 36.9501 16.0673 36.9502 10.5008H36.9506C36.9506 7.16087 39.6532 4.45331 42.987 4.45331C46.3209 4.45331 49.0235 7.16087 49.0235 10.5008L53.0478 10.5008C53.0478 4.93424 48.5434 0.421631 42.987 0.421631C37.4307 0.421631 32.9264 4.93418 32.9263 10.5007H32.9259C32.9259 13.8406 30.2233 16.5482 26.8895 16.5482Z",
    fill: "#2ED02A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -7.26367,
    y: -3.57886,
    width: 28.1214,
    height: 28.1584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.04946,
    y1: 4.69248,
    x2: 25.1663,
    y2: 12.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285554,
    stopColor: "#2ED02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#1E961B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 52.148,
    y1: 6.46353,
    x2: 32.354,
    y2: 14.2249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285554,
    stopColor: "#2ED02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762026,
    stopColor: "#1E961B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/BrandIcon.357598cb30835064097e7b44ae73d91f.svg";
export { ForwardRef as ReactComponent };